// extracted by mini-css-extract-plugin
module.exports = {"side-panel__sticky":"styles_side-panel__sticky__SseOG","side-panel__sticky-long":"styles_side-panel__sticky-long__1Vwv9"};